import moment from 'moment-timezone'

const DAY_MONTH_FORMAT = 'MMMM D'
const DAY_MONTH_YEAR_FORMAT = `${DAY_MONTH_FORMAT}, YYYY`

export default (
  startDate: string | Date,
  endDate: string | Date,
  formatDM: string = DAY_MONTH_FORMAT,
  formatDMY: string = DAY_MONTH_YEAR_FORMAT
): string => {
  const start = moment.utc(startDate)
  const end = moment.utc(endDate)

  const formattedStart =
    start.year() === end.year() ? start.format(formatDM) : start.format(formatDMY)
  const formattedEnd = end.format(formatDMY)

  return `${formattedStart} - ${formattedEnd}`
}
